goog.provide('el8.appchart.dialog.viewInlineHl7');

goog.require('el8.app.pageLayout');
goog.require('el8.appservice.notifier');
goog.require('el8.uiwidget.alert');
goog.require('el8.uiwidget.ButtonSet');
goog.require('el8.uiwidget.NewDialog');
goog.require('el8.template.appchart.dialog.viewInlineHl7');


/**
 * This dialog renders an hl7Message.
 */
el8.appchart.dialog.viewInlineHl7 = (function() {

    var patientId = null;
    var messageId = null;

    var that = new el8.uiwidget.NewDialog({
        width: 570,
        height: function() {
            return el8.app.pageLayout.getChartInnerHeight();
        },
        position: 'center',
        showXButton: true
    });
    var buttonSet = new el8.uiwidget.ButtonSet();
    buttonSet.addButton(
        'sign', 'Sign Off', function() { signFn(false); }, false
    );

    that.setButtonSet(buttonSet);

    var super_show = that.show;
    that.show = function(spec) {
        super_show.call(that);

        patientId = spec.patientId || el8Globals.PATIENT_ID;
        messageId = spec.messageId;

        var hl7Url = el8.service.urls.get('getHl7InlineContent', [patientId, messageId]);
        asyncLoadHl7Doc(hl7Url).done(function(data) {
            that.setContent(el8.template.appchart.dialog.viewInlineHl7.content({data: data}));
        });

        that.setTitle(spec.title || 'Patient Immunization Summary');
    };

    var super_hide = that.hide;
    that.hide = function() {
        super_hide.call(that);
        that.setContent(el8.template.appchart.dialog.viewInlineHl7.content({})); // clear contents

        patientId = null;
        messageId = null;
    };

    var super_adjustPosition = that.adjustPosition;
    that.adjustPosition = function() {
        super_adjustPosition.call(that);
    };

    // Just returns an AJAX request that can be passed in to the $.when clause
    function asyncLoadHl7Doc(url) {
        return $.el8_ajax({
            type: 'GET',
            url: url,
            async: true
        });
    }

    function signFn() {
        alert("signing");
    }
    // function signFn(doImport) {
    //     var xmlSummary = el8.ptdata.xmlSummaries.getById(summaryId);
    //
    //     var behalfUserId = null;
    //     var $physicianSelect = $(':input[name="physicianUser"]', that.getContentElt());
    //     if ($physicianSelect.length) {
    //         behalfUserId = $physicianSelect.val()*1;
    //     }
    //     var $signImportBtn = that.getButtonElt().find('.el8ButtonItem button[name="sign-import"]');
    //     if (doImport) {
    //         el8.appservice.notifier.notify('Signing off and importing data from patient summary...');
    //         // going to disable button to prevent double clicking
    //         $signImportBtn.prop('disabled', true);
    //     }
    //     xmlSummary.sign({
    //         doImport: doImport,
    //         behalfUserId: behalfUserId,
    //         successCb: function(updatedSummary, rawData) {
    //             if (doImport) {
    //                 el8.appservice.notifier.notify('Data from patient summary imported.');
    //             }
    //             $('.import-button-section', that.getContentElt()).replaceWith(
    //                 el8.template.appchart.dialog.viewInlineCda.buttonSection(updatedSummary.asSoyMap())
    //             );
    //             buttonSet.hideButton('sign');
    //             buttonSet.hideButton('sign-import');
    //             buttonSet.hideButton('sign-import-qrda');
    //             $('.select-physician-section', that.getContentElt()).remove();
    //             renderImportedList();
    //             if (rawData.changed_sections) {
    //                 el8.appchart.mainFeeds.chartFileUploader.refreshChangedSections(rawData.changed_sections);
    //             }
    //         },
    //         completeCb: function() {
    //             $signImportBtn.prop('disabled', false);
    //             el8.ptdata.hccScoreDetails.refreshIfHccScoreEnabled();
    //         }
    //     });
    // }

    return that;

})();
